import {Component, OnInit} from '@angular/core';
import {DataService} from "../services/data.service";
import {ApiService} from "../services/api.service";

@Component({
    selector: 'app-company-import',
    templateUrl: './company-import.component.html',
    styleUrls: ['./company-import.component.css']
})
export class CompanyImportComponent implements OnInit {

    node = 'company';
    company = {};
    ApiUrl;
    importFile;

    constructor(
        private dataService: DataService,
        private apiService: ApiService
    ) {
    }

    ngOnInit() {
        this.dataService.refresh();
    }

    fileChange(event) {
        let fileList: FileList = event.target.files;
        if(fileList.length > 0) {
            let file: File = fileList[0];
            let formData:FormData = new FormData();
            formData.append('import_file', file, file.name);
            this.importFile = formData;
            console.log(this.importFile);
        }
    }

    onImport() {
        this.apiService.importFile(this.node, this.importFile)
            .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    alert(response.json().message);
                },
                (error) => alert('unexpected error occur')
            );
    }

    checkPermission(module, method) {
        return this.dataService.checkPermission(module, method);
    }

}



// WEBPACK FOOTER //
// ./src/app/company-import/company-import.component.ts